module.exports = __webpack_public_path__ + "344f69d0bd994daa1bab35e3cbe398b2.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/KE.svg
// module id = Rtcn
// module chunks = 0